import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface ResetClimberProfileModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  error?: Error | null;
}

export default function ResetClimberProfileModal({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  error = null,
}: ResetClimberProfileModalProps) {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "rgba(28, 37, 46, 0.95)",
          color: "white",
          border: "1px solid #c4cdd5",
        },
      }}
    >
      <DialogTitle sx={{ fontFamily: "Proxima Nova", fontWeight: 700 }}>
        Reset Climber Profile
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontFamily: "Proxima Nova", lineHeight: "24px" }}>
          This permanently clears everything you did in Climber Mode &mdash;
          your profile, hats, career and course plans, badges, XP and all
          progress. It cannot be undone.
        </Typography>
        <Typography
          sx={{ fontFamily: "Proxima Nova", lineHeight: "24px", mt: 2 }}
        >
          Your coach work is not affected. Shout outs you wrote, career plan
          feedback you left, your classes and your students&apos; data all stay
          exactly as they are.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          onClick={onClose}
          disabled={isLoading}
          sx={{
            color: "white",
            borderColor: "white",
            "&:hover": {
              borderColor: "white",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {isLoading ? "Resetting..." : "Reset Profile"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
